<!-- App Logo -->
<div class="logo-section">
  <img [src]="isUAT ? 'assets/symbol/symbol-fill-uat-500.png' : 'assets/symbol/symbol-fill-prod-500.png'"
       alt="logo" class="logo">
</div>

<!-- Main Content Section -->
<div class="main-content">
  <!-- Filter Icons Section -->
  <div class="filter-section">

    <!-- Recurring/Non-Recurring Filter -->
    <div class="filter-group">
      <ul class="filter-list">
        <li>
          <div class="menu-container">
            <button mat-icon-button
                    [class.active]="recurringFilter !== 'all'"
                    (mouseenter)="onButtonMouseEnter($event, 'recurring')"
                    (mouseleave)="onButtonMouseLeave('recurring')"
                    [matTooltip]="getRecurringTooltip()"
                    [matTooltipPosition]="'right'">
              <mat-icon>{{getRecurringIcon()}}</mat-icon>
            </button>
            <app-mini-menu [options]="recurringOptions"
                          [isVisible]="showRecurringMenu"
                          [selectedValue]="recurringFilter"
                          [buttonTop]="recurringButtonTop"
                          (optionSelected)="onRecurringOptionSelected($event)"
                          (visibilityChange)="showRecurringMenu = $event">
            </app-mini-menu>
          </div>
        </li>
      </ul>
    </div>

    <!-- Status Filter -->
    <div class="filter-group">
      <ul class="filter-list">
        <li>
          <div class="menu-container">
            <button mat-icon-button
                    [class.active]="statusFilter !== 'pending'"
                    (mouseenter)="onButtonMouseEnter($event, 'status')"
                    (mouseleave)="onButtonMouseLeave('status')"
                    [matTooltip]="getStatusTooltip()"
                    [matTooltipPosition]="'right'">
              <mat-icon>{{getStatusIcon()}}</mat-icon>
            </button>
            <app-mini-menu [options]="statusOptions"
                          [isVisible]="showStatusMenu"
                          [selectedValue]="statusFilter"
                          [buttonTop]="statusButtonTop"
                          (optionSelected)="onStatusOptionSelected($event)"
                          (visibilityChange)="showStatusMenu = $event">
            </app-mini-menu>
          </div>
        </li>
      </ul>
    </div>

    <!-- Resident Filter -->
    <div class="filter-group">
      <ul class="filter-list">
        <li>
          <div class="menu-container">
            <button mat-icon-button
                    [class.active]="residentFilter !== null"
                    (mouseenter)="onButtonMouseEnter($event, 'resident')"
                    (mouseleave)="onButtonMouseLeave('resident')"
                    [matTooltip]="getResidentTooltip()"
                    [matTooltipPosition]="'right'">
              <mat-icon>{{getResidentIcon()}}</mat-icon>
            </button>
            <app-mini-menu [options]="residentOptions"
                          [isVisible]="showResidentMenu"
                          [selectedValue]="residentFilter"
                          [buttonTop]="residentButtonTop"
                          (optionSelected)="onResidentOptionSelected($event)"
                          (visibilityChange)="showResidentMenu = $event">
            </app-mini-menu>
          </div>
        </li>
      </ul>
    </div>

  </div>

  <!-- Footer Section -->
  <div class="footer-section">
    <!-- Environment Toggle -->
    <button mat-button
            (click)="toggleEnvironment()"
            [matTooltip]="isUAT ? 'Switch to PROD' : 'Switch to UAT'"
            [matTooltipPosition]="'right'"
            class="env-toggle"
            [class.prod-button]="!isUAT"
            [class.uat-button]="isUAT">
      {{ isUAT ? 'UAT' : 'PROD' }}
    </button>
  </div>
</div>

<mat-menu #settingsMenu="matMenu">
  <button mat-menu-item (click)="resetFilters()">
    <mat-icon>restart_alt</mat-icon>
    Reset Filters
  </button>
</mat-menu>
